module.exports = __webpack_public_path__ + "static/parade-2020-house45-998f01e722a5bf08281bc36fae07b91c.jpg";